//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"NumberOfParameters",0,0],[0,"OutputLoadTool",1,0],[0,"UdeName",1,0]],[[["parameterName"],"GetParameter",{R_:{parameter:"CAM.UdeParameter"}},1,0],[["index"],"GetParameter1",{R_:{parameter:"CAM.UdeParameter"}},1,0],[["count"],"GetParameterNames",{R_:{parameterNames:""}},0,0],[["udeObjToInitializeFrom"],"InitializeFrom",{R_:{success:''}},1,0]],[]];
SPLM.CAM.Ude = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.Ude";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;